document.addEventListener("DOMContentLoaded", function() {
  $(".modal").on("click", ".close", function() {
    var modalEl = $(this).closest(".modal")[0];
    var modal = bootstrap.Modal.getInstance(modalEl);
    if (modal) modal.hide();
  });
});
